import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
export var StyledModalFooter = styled("footer")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    flex: 0 0 auto;\n    padding: ", "px;\n"])), sizes.xLarge);
export var StyledFooterButtons = styled("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    margin-left: auto;\n"])));
//# sourceMappingURL=Footer.js.map